

















import FrequencyBar from './scripts';
export default FrequencyBar;
